// Mapping icona/etichetta per la categoria degli eventi del calendario unificato
// (GET /api/calendario). "categoria" arriva dal backend con questi valori esatti:
// "Manutenzione" | "Mezzo" | "Pagamento".
const CATEGORIE = {
    Manutenzione: { icona: "mdi-cog", label: "Manutenzione macchinario" },
    Mezzo: { icona: "mdi-truck", label: "Scadenza mezzo" },
    Pagamento: { icona: "mdi-cash", label: "Pagamento" },
    Sicurezza: { icona: "mdi-shield-check", label: "Sicurezza" },
};

export function iconaCategoria(categoria) {
    return (CATEGORIE[categoria] || {}).icona || "mdi-calendar";
}

export function etichettaCategoria(categoria) {
    return (CATEGORIE[categoria] || {}).label || categoria || "";
}
